// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"f654b68f24aa9b5038e1","883":"49b2a05aecff03969ae1"}[chunkId] + ".js";
};